import axios from "axios";
import store from "@/store";

import colors from "vuetify/lib/util/colors";
import vuetify from "../../plugins/vuetify";

import Vue from "vue";
import user from "./user";

const state = {
  //Set any/all variables we'll need before our configs are loaded in
  // -- This is just to ensure we can render our components correctly
  primary_bg: colors.blue.darken2,
  primary_menu_color: colors.blue.darken2,
  primary_menu_icon: colors.blue.darken2,

  // background: colors.grey.darken4,
  // background_alt: colors.shades.white,
};

const getters = {
  retrieveAllConfigs: (state) => {
    return state;
  },

  retrieveShowPrices: (state) => {
    let show_prices = parseInt(state.show_prices);

    // IF show_prices = 1 or Unset then show prices
    // - ELSE IF show_prices = 0 then hide prices on the front end
    // - ELSE IF show_prices = 2 then hide prices for anonymous users only

    console.log(show_prices)
    console.log('show_prices')
    if (
      (show_prices == 2 && store.getters.retrieveGuest == true) ||show_prices == 0) {
      
        return false;

    } else  {

      return true;
    }
  },
  retrieveMinimumSearchConfig: (state) => {
    let chars = 3;

    if (state.orders_search_min_chars) {
      chars = parseInt(state.orders_search_min_chars);
    }

    return chars;
  },

  retrievePostcodeDeliveryDays: (state) => {
    let value = false;

    if (state.cashsales_postcode_delivery_days) {
      value = parseInt(state.cashsales_postcode_delivery_days);
    }

    return value;
  },

  retrieveOrderDiscountsEnabled: (state) => {
    let value = false;

    if (state.orders_discounts_enabled) {
      value = parseInt(state.orders_discounts_enabled);
    }

    return value;
  },

  retrieveMinimumSearchCharacters: (state) => {
    let chars = 3;

    if (state.orders_search_min_chars) {
      if (parseInt(state.orders_search_min_chars) > 3) {
        chars = parseInt(state.orders_search_min_chars);
      }
    }

    return chars;
  },

  retrieveShowDistributorFilters: (state) => {
    let enabled = false;

    if (state.orders_create_filters_distributors) {
      enabled = parseInt(state.orders_create_filters_distributors);
    }

    return enabled;
  },

  retrieveStripeClientKey: (state) => {
    return state.stripe_client_key;
  },

  retrieveAllergenText(state) {
    return state.allergen_text;
  },

  retrieveCncOrdersEnabled: (state) => {
    if (state.orders_cnc_enabled) {
      if (state.orders_cnc_enabled == "1") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  retrieveStockConfig: (state) => {
    let stockUrl = false;
    if (state.stock_url && state.stock_url !== "") {
      stockUrl = true;
    }
    return stockUrl;
  },

  isBusinessRegistrationEnabled: (state) => {
    console.log("-- Getting Business user Registration");
    if (state.business_account_registration) {
      console.log(state.business_account_registration);
      console.log(1);
      if (state.business_account_registration == "1") {
        console.log(3);
        return true;
      } else {
        console.log(4);
        return false;
      }
    } else {
      console.log(2);
      return false;
    }
  },

  isCashUserRegistrationEnabled: (state) => {
    console.log("-- Getting Cash Account Registration");
    if (state.cash_user_registration) {
      console.log(state.cash_user_registration);
      console.log(1);
      if (state.cash_user_registration == "1") {
        console.log(3);
        return true;
      } else {
        console.log(4);
        return false;
      }
    } else {
      console.log(2);
      return false;
    }
  },

  isCashUserLoginEnabled: (state) => {
    if (state.cash_user_login) {
      return state.cash_user_login == 1;
    }
    return false;
  },

  retrieveCncAddress: (state) => {
    if (state.cnc_postcode) {
      return {
        address_line_1: state.cnc_address_line_1,
        address_line_2: state.cnc_address_line_2,
        address_line_3: state.cnc_address_line_3,
        address_line_4: state.cnc_address_line_4,
        postcode: state.cnc_postcode,
        telephone_no: state.cnc_telephone,
      };
    }
  },

  retrieveCncInfoText: (state) => {
    let info = "";
    if (state.orders_cnc_collection_info) {
      info = state.orders_cnc_collection_info;
    }
    return info;
  },

  retrieveAccountAnnouncmentMessage: (state) => {
    let announcementMessage = null;

    if (state.announcement_message) {
      announcementMessage = state.announcement_message;
    }

    return announcementMessage;
  },
  retrieveCashAnnouncmentMessage: (state) => {
    let announcementMessage = null;

    if (state.cash_user_announcement_message) {
      announcementMessage = state.cash_user_announcement_message;
    }

    return announcementMessage;
  },

  retrieveCompanyHomePageText: (state) => {
    let companyHomePageText = "No Message Found";

    if (state.company_home_page_text) {
      companyHomePageText = state.company_home_page_text;
    }

    return companyHomePageText;
  },

  retrieveCompanyWelcomePageText: (state) => {
    let companyWelcomePageText = "no-message";

    if (state.company_welcome_page_text) {
      companyWelcomePageText = state.company_welcome_page_text;
    }

    return companyWelcomePageText;
  },

  retrieveAllowAnonUsers: (state) => {
    //Default to true
    let result = true;

    if (state.allow_anon_users == "0") {
      result = false;
    }

    return result;
  },

  retrieveCashDescriptionForAccounts: (state) => {
    let value = null;

    if (state.orders_create_cs_cnc_desc_accounts) {
      value = parseInt(state.orders_create_cs_cnc_desc_accounts);
    }

    return value;
  },

  retrieveMinimumOrderValue: (state) => {
    let minimumOrderValue = 0;

    if (
      store.getters.retrieveIsCashCustomer ||
      store.getters.retrieveIsCncCustomer
    ) {
      if (state.cash_user_min_order_value) {
        minimumOrderValue = parseFloat(state.cash_user_min_order_value);
      }
    }

    //cash_user_min_order_value

    return minimumOrderValue;
  },

  retrieveCutOffTime: (state) => {
    let cutOffHour = 23;

    if (store.getters.retrieveIsCashCustomer) {
      if (state.orders_cash_next_day_cutoff_time_final) {
        cutOffHour = parseInt(state.orders_cash_next_day_cutoff_time_final);
      } else {
        cutOffHour = 16;
      }
    } else if (store.getters.retrieveIsCncCustomer) {
      if (state.orders_cnc_next_day_cutoff_time_final) {
        cutOffHour = parseInt(state.orders_cnc_next_day_cutoff_time_final);
      } else {
        cutOffHour = 16;
      }
    } else {
      if (state.orders_next_day_cutoff_time_final) {
        cutOffHour = parseInt(state.orders_next_day_cutoff_time_final);
      } else {
        cutOffHour = 23;
      }
    }

    //cash_user_min_order_value

    return cutOffHour;
  },
  retrieveCutOffTimeWarning: (state) => {
    return state.orders_next_day_cutoff_time_warning;
  },

  retrievePrimaryBg: (state) => {
    return state.primary_bg;
  },

  retrieveBackgroundAlt: (state) => {
    return state.background_alt;
  },

  retrieveMenuColor: (state) => {
    return state.menu_color;
  },
  retrieveMenuIcon: (state) => {
    return state.menu_icon;
  },

  retrieveCompanyWelcomeImage1: (state) => {
    let value = false;

    if (state.company_welcome_image_1) {
      value = state.company_welcome_image_1;
    }

    return value;
  },

  retrieveCompanyWelcomeImage2: (state) => {
    let value = false;

    if (state.company_welcome_image_2) {
      value = state.company_welcome_image_2;
    }

    return value;
  },

  isCategoriesShowEnabled: (state) => {
    let showCats = false;

    if (state.show_group_categories && state.show_group_categories == "1") {
      showCats = true;
    }
    return showCats;
  },

  retrieveMenuOptions: (state) => {
    let menuOptions = {
      Orders: {
        show: 1,
        title: "Orders",
        icon: "mdi-credit-card-outline",
        color: "success",
        subItems: {
          Create: {
            show: 1,
            title: "Create Order",
            icon: "mdi-file-document-edit-outline",
            link: "/orders/create",
          },
          Template: {
            show: 1,
            title: "Template Orders",
            icon: "mdi-format-list-checkbox",
            link: "/orders/template",
          },
          Standing: {
            show: 0,
            title: "Standing Orders",
            icon: "mdi-file-clock-outline",
            link: "/orders/standingorders",
          },
          View: {
            show: 1,
            title: "Your Orders",
            icon: "mdi-card-search-outline",
            link: "/orders/yourorders",
          },
        },
      },
      Accounts: {
        show: 0,
        title: "Accounts",
        icon: "mdi-trending-up",
        color: "primary",
        subItems: {
          Invoice: {
            show: 0,
            title: "Copy Invoice",
            icon: "mdi-clipboard-file-outline",
            link: "/accounts/invoice",
          },
          Statement: {
            show: 0,
            title: "Copy Statement",
            icon: "mdi-content-copy",
            link: "/accounts/statement",
          },
          Payment: {
            show: 0,
            title: "Payment on Account",
            icon: "mdi-credit-card-outline",
            link: "/accounts/payment",
          },

          PaymentHistory: {
            show: 0,
            title: "Payment History",
            icon: "history",
            link: "/accounts/paymenthistory",
          },
        },
      },
      Reports: {
        show: 3,
        title: "Reports",
        icon: "mdi-file-chart-outline",
        color: "purple",
        subItems: {
          Sales: {
            show: 3,
            title: "Product Sales",
            icon: "mdi-chart-bar",
            link: "/reports/sales",
          },
          Allergen: {
            show: 3,
            title: "Allergen Report",
            icon: "mdi-alert",
            link: "/reports/allergen",
          },
          Nutrition: {
            show: 3,
            title: "Nutrition Information",
            icon: "mdi-alert-circle-outline",
            link: "/reports/nutrition",
          },
        },
      },

      Maintenance: {
        show: 5,
        title: "Maintenance",
        icon: "mdi-database",
        color: "purple",
        subItems: {
          Postcodes: {
            show: 5,
            title: "Postcodes",
            icon: "mdi-post",
            link: "/maintenance/postcodes",
          },

          OrderDiscounts: {
            show: 5,
            title: "Order Discounts",
            icon: "mdi-tag",
            link: "/maintenance/orderdiscounts",
          },
        },
      },
    };

    //Override our Order Options here
    console.log("== Checking Orders Menu ==");
    console.log(store.getters.retrieveAnon);

    //Orders has sub options only
    if (state.orders_create_order_show) {
      menuOptions.Orders.subItems.Create.show = parseInt(
        state.orders_create_order_show
      );
    }

    if (state.orders_template_orders_show && !store.getters.retrieveAnon) {
      menuOptions.Orders.subItems.Template.show = parseInt(
        state.orders_template_orders_show
      );
    } else if (store.getters.retrieveAnon) {
      menuOptions.Orders.subItems.Template.show = 0;
    }

    if (
      (store.getters.retrieveIsCashCustomer && !store.getters.retrieveAnon) ||
      (store.getters.retrieveIsCncCustomer && !store.getters.retrieveAnon)
    ) {
      menuOptions.Orders.subItems.Standing.show = 0;
    } else if (store.getters.retrieveAnon) {
      menuOptions.Orders.subItems.Standing.show = 0;
    } else {
      if (state.orders_standing_orders_show) {
        menuOptions.Orders.subItems.Standing.show = parseInt(
          state.orders_standing_orders_show
        );
      }
    }

    if (state.orders_your_order_show && !store.getters.retrieveAnon) {
      menuOptions.Orders.subItems.View.show = parseInt(
        state.orders_your_order_show
      );
    } else if (store.getters.retrieveAnon) {
      menuOptions.Orders.subItems.View.show = 0;
    }

    // -- Main Option
    console.log("== Checking Account Menu ==");
    console.log(store.getters.retrieveIsCashCustomer);
    console.log(store.getters.retrieveIsCncCustomer);

    if (
      store.getters.retrieveIsCashCustomer ||
      store.getters.retrieveIsCncCustomer
    ) {
      console.log("-- Hiding Account Menu");
      menuOptions.Accounts.show = 0;
    } else {
      if (state.accounts_menu_show) {
        menuOptions.Accounts.show = parseInt(state.accounts_menu_show);
      }
    }

    // -- Sub Options
    if (state.accounts_copy_invoice_show) {
      menuOptions.Accounts.subItems.Invoice.show = parseInt(
        state.accounts_copy_invoice_show
      );
    }
    if (state.accounts_copy_statement_show) {
      menuOptions.Accounts.subItems.Statement.show = parseInt(
        state.accounts_copy_statement_show
      );
    }

    if (state.accounts_payment_show) {
      menuOptions.Accounts.subItems.Payment.show = parseInt(
        state.accounts_payment_show
      );
    }

    if (state.accounts_paymenthistory_show) {
      menuOptions.Accounts.subItems.PaymentHistory.show = parseInt(
        state.accounts_paymenthistory_show
      );
    }

    //Override our Reports Options here
    // -- Main Option
    if (
      store.getters.retrieveIsCashCustomer ||
      store.getters.retrieveIsCncCustomer
    ) {
      console.log("-- Hiding Account Menu");
      menuOptions.Reports.show = 0;
    } else {
      if (state.reports_menu_show) {
        menuOptions.Reports.show = parseInt(state.reports_menu_show);
      }
    }

    // -- Sub Options
    if (state.reports_product_sales_show) {
      menuOptions.Reports.subItems.Sales.show = parseInt(
        state.reports_product_sales_show
      );
    }
    if (state.reports_allergen_show) {
      menuOptions.Reports.subItems.Allergen.show = parseInt(
        state.reports_allergen_show
      );
    }
    if (state.reports_allergen_show) {
      menuOptions.Reports.subItems.Nutrition.show = parseInt(
        state.reports_allergen_show
      );
    }

    return menuOptions;
  },
};

const actions = {
  async getConfigs({ commit }) {
    await axios
      .get("get-config", {
        params: {
          params: {
            group: "cpgo",
            identity: "nws9987",
          },
        },
      })
      .then((response) => {
        if (response.data.success) {
          commit("setConfigs", response.data.config);

          //Set Config Default Here
          let storeSynonym = store.getters.retrieveProductSynonym;
          console.log("Store Synonym Value");
          console.log(storeSynonym);

          if (store.getters.retrieveProductSynonym == null) {
            console.log("Null Synonym Value");

            response.data.config.forEach((config) => {
              if (config.var_name == "orders_search_show_synonym") {
                console.log("Synonym Default");
                console.log(config.var_value);

                if (config.var_value == "1") {
                  console.log("Set Synonym to Show");
                  store.dispatch("setProductSynonym", true);
                } else if (config.var_value == "0") {
                  console.log("Set Synonym to Hide");
                  store.dispatch("setProductSynonym", false);
                }
              }
            });
          }

          if (store.getters.retrieveQtyInBox == null) {
            console.log("Null Product Qty In Box Value");

            response.data.config.forEach((config) => {
              if (config.var_name == "orders_search_show_prod_qty_in_box") {
                console.log("Qty Default");
                console.log(config.var_value);

                if (config.var_value == "1") {
                  console.log("Set Qty to Show");
                  store.dispatch("setProductQtyInBox", true);
                } else if (config.var_value == "0") {
                  console.log("Set Qty to Hide");
                  store.dispatch("setProductQtyInBox", false);
                }
              }
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
};

const mutations = {
  setConfigs: (state, configs) => {
    console.log("-- New Reactive Configs?");
    console.log(state);
    console.log(configs);
    // state.push(configs);

    configs.forEach((config) => {
      Vue.set(state, config.var_name, config.var_value);
    });

    console.log(state);

    //Now we've updated our state let's update our theme
    store.dispatch("setCaterpointTheme");

    if (store.getters.retrieveCustomTheme) {
      //We Are using a custom theme so get the details and load them
      console.log("-- Apply Custom Theme");
      store.dispatch(
        "setVuetifyTheme",
        store.getters.retrieveCustomThemeDetails
      );
    } else {
      //We're not so revert to standard Caterpoint theme
      console.log("-- Apply Caterpoint Theme");
      store.dispatch(
        "setVuetifyTheme",
        store.getters.retrieveCaterpointThemeDetails
      );
    }

    // vuetify.framework.theme.themes.light.primary = state.css_primary_bg;
    // // vuetify.framework.theme.themes.dark.primary = state.css_primary_bg;
    // //-- Don't load in the primary colour on the dark theme
    // vuetify.framework.theme.themes.dark.primary = "#1984c3";

    // // vuetify.framework.theme.themes.light.background_alt =
    // //   state.css_primary_bg_alt;
    // // vuetify.framework.theme.themes.dark.background_alt = colors.grey.darken4;

    // vuetify.framework.theme.themes.light.menu_color =
    //   state.css_menu_button_text;
    // vuetify.framework.theme.themes.dark.menu_color = colors.grey.lighten5;

    // vuetify.framework.theme.themes.light.menu_icon = state.css_menu_button_icon;
    // vuetify.framework.theme.themes.dark.menu_icon = colors.grey.lighten3;

    return;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
